const { generateFieldMask, applyFieldMask } = require('./lib/fieldmask')

module.exports.generateFieldMask = generateFieldMask
module.exports.applyFieldMask = applyFieldMask
